import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent } from "@/components/ui/card";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import SupportTicketForm from "@/components/support/SupportTicketForm";
import FAQSection from "@/components/support/FAQSection";
import { 
  HelpCircle, 
  MessageCircle, 
  Mail,
  Clock,
  Shield
} from "lucide-react";

const SupportPage = () => {
  const [activeTab, setActiveTab] = useState("faq");

  const handleContactSupport = () => {
    setActiveTab("contact");
  };

  const handleTicketCreated = (ticketNumber: string) => {
    // Could redirect to a ticket tracking page or show success message
    console.log('Ticket created:', ticketNumber);
  };

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      <div className="pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="container mx-auto max-w-6xl">
          <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-8">
            <div className="text-center space-y-6">
              <h1 className="text-4xl sm:text-5xl font-bold">
                Support
                <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
                  {" "}Center
                </span>
              </h1>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Get the help you need with CareKonnect. Browse our FAQ, submit a support ticket, or contact us directly.
              </p>
              
              <TabsList className="grid w-full max-w-lg mx-auto grid-cols-2">
                <TabsTrigger value="faq" className="flex items-center gap-2">
                  <HelpCircle className="w-4 h-4" />
                  FAQ
                </TabsTrigger>
                <TabsTrigger value="contact" className="flex items-center gap-2">
                  <MessageCircle className="w-4 h-4" />
                  Contact
                </TabsTrigger>
              </TabsList>
            </div>

            <TabsContent value="faq" className="space-y-0">
              <FAQSection onContactSupport={handleContactSupport} />
            </TabsContent>

            <TabsContent value="contact" className="space-y-8">
              <div className="grid lg:grid-cols-2 gap-8">
                {/* Support Form */}
                <div>
                  <SupportTicketForm onTicketCreated={handleTicketCreated} />
                </div>

                {/* Contact Information & Support Hours */}
                <div className="space-y-6">
                  {/* Contact Details */}
                  <Card>
                    <CardContent className="p-6 space-y-6">
                      <div className="flex items-start space-x-4">
                        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                          <Mail className="w-5 h-5 text-primary" />
                        </div>
                        <div>
                          <div className="font-semibold">Email Support</div>
                          <div className="text-muted-foreground">hellocarekonnect@gmail.com</div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>

                  {/* Support Hours */}
                  <Card className="bg-gradient-to-br from-primary/5 to-accent/5">
                    <CardContent className="p-6">
                      <div className="flex items-center gap-2 mb-4">
                        <Clock className="w-5 h-5 text-primary" />
                        <h3 className="text-lg font-semibold">Support Hours</h3>
                      </div>
                      <div className="space-y-3">
                        <div className="flex justify-between">
                          <span className="text-sm">Monday - Friday</span>
                          <span className="text-sm font-medium">8:00 AM - 6:00 PM CST</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm">Saturday</span>
                          <span className="text-sm font-medium">9:00 AM - 2:00 PM CST</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm">Sunday</span>
                          <span className="text-sm font-medium">Emergency Only</span>
                        </div>
                        <div className="pt-2 border-t border-border/50">
                          <div className="text-xs text-muted-foreground flex items-center gap-2">
                            <Shield className="w-3 h-3" />
                            24/7 emergency support available for Enterprise customers
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>

                </div>
              </div>
            </TabsContent>


          </Tabs>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SupportPage;